import React from 'react';
import Header from '../../Includes/Header';
import Footer from '../../Includes/Footer';
import "./ZiplyfiberProvider.css"
import logo1 from "../../Includes/Images/head-logo.png";
import provider1 from "../../Includes/Images/Group-1171274976-7.png";
import provider2 from "../../Includes/Images/Frame-48.png";
import provider3 from "../../Includes/Images/Frame-49.png";
import provider4 from "../../Includes/Images/Rectangle-8-3.png";
import provider5 from "../../Includes/Images/Frame-50.png";
import provider6 from "../../Includes/Images/Frame-51.png";
import provider7 from "../../Includes/Images/Frame-52.png";
import provider8 from "../../Includes/Images/Frame-53.png";
import WideCoverage from './WideCoverage';

const ZiplyfiberProvider = () => {
  return (
    <>
    <Header/>
    <div className="ziply-container">
      {/* Header with Logo */}

      {/* Hero Section */}
      <section className="ziply-hero bg-green-900 text-white py-12 text-center relative">
      <header className="ziply-header">
        <div className="ziply-logo-container">
          <img src={logo1} alt="Ziply Fiber Logo" className="ziply-logo" />
        </div>
      </header>
        <div className="container mx-auto px-4">
          <h1 className="text-3xl md:text-4xl font-bold mb-2">
            Get the fastest fiber-ziplyic<br />internet in America with
          </h1>
          <h2 className="text-4xl md:text-5xl font-bold mt-2 text-green-100">
            Ziply Fiber
          </h2>
        </div>
        
        {/* Feature Images */}
        <div className="ziply-features-grid flex flex-wrap justify-center mt-8">
          <div className="ziply-feature-item w-1/2 md:w-1/4 p-1">
            <img src={provider1} alt="Person using laptop" className="rounded-lg w-full h-auto" />
          </div>
        </div>
      </section>

      {/* Why Choose Section */}
      <section className="ziply-why-choose py-10">
        <div className="container mx-auto px-4">
          <h2 className="text-2xl md:text-3xl font-bold mb-8">What Makes Ziply Fiber A Good Choice?</h2>
          
          <div className="ziply-features flex flex-wrap">
            <div className="ziply-feature-text w-full md:w-1/2 pr-0 md:pr-8 mb-6">
              <p className="text-sm mb-4">Ziply Fiber's Multi-Gig Internet Plans Are Built To Bring You The Speed And Reliability You Need Today And For The Future. Choose From 1 Gig, 2 Gig, 5 Gig Or Even 10 Gig Internet Speeds – The Fastest Home Internet Plan In America.</p>
              
              <a href="tel:18442737297" className="ziply-phone-btn bg-green-700 text-white py-2 px-4 rounded-full inline-flex items-center mt-2">
                <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5 mr-2" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 5a2 2 0 012-2h3.28a1 1 0 01.948.684l1.498 4.493a1 1 0 01-.502 1.21l-2.257 1.13a11.042 11.042 0 005.516 5.516l1.13-2.257a1 1 0 011.21-.502l4.493 1.498a1 1 0 01.684.949V19a2 2 0 01-2 2h-1C9.716 21 3 14.284 3 6V5z" />
                </svg>
                +1-888-348-6689
              </a>
            </div>
            
            <div className="w-full md:w-1/2 flex flex-wrap">
              <div className="w-1/2 pr-2 mb-6">
                <img src={provider2} alt="5G technology" className="rounded-lg w-full h-auto" />
                <h3 className="font-bold mt-4 mb-2">No Hidden Charges</h3>
                <p className="text-sm">Advertised rates of service with zero hidden fees or surprise alternatives to cable.</p>
              </div>
              
              <div className="w-1/2 pl-2 mb-6">
                <img src={provider3} alt="Fiber ziplyic cable" className="rounded-lg w-full h-auto" />
                <h3 className="font-bold mt-4 mb-2">Modernize Your Home</h3>
                <p className="text-sm">Modernize your home internet with plans tailored to your needs, starting as low as $20/month.</p>
              </div>
            </div>
          </div>
        </div> 
      </section>

      {/* Plans Section */}
      <div className="ziply-plans-section">
    <h2 className="ziply-section-title">Fast fiber speeds to meet all your needs</h2>

    <div className="ziply-plan-cards">
        {/* <!-- Plan 1 --> */}
        <div className="ziply-plan-card">
            <h3 className="ziply-plan-name">FIBER 50/50</h3>
            <p className="ziply-plan-from">From</p>
            <p className="ziply-plan-price"><span>$</span>20</p>
            <p className="ziply-plan-period">Monthly</p>
            <ul className="ziply-plan-features">
                <li><span className="ziply-check-icon">✓</span> Symmetric 50 Mbps Upload and Download Speeds</li>
                <li><span className="ziply-check-icon">✓</span> Enjoy unlimited internet access on up to 4 devices</li>
                <li><span className="ziply-check-icon">✓</span> Watch your favorite movies and TV shows</li>
                <li><span className="ziply-check-icon">✓</span> Engage with your loved ones through video conferencing</li>
                <li><span className="ziply-check-icon">✓</span> No annual contracts</li>
            </ul>
            <a href="tel:+18442172287" className="ziply-plan-btn">+1-888-348-6689</a>
            <p className="ziply-disclaimer">Not available in all areas. Advertised speed for wired connection. Actual speeds, including over WiFi, may vary and are not guaranteed.</p>
        </div>

        {/* <!-- Plan 2 --> */}
        <div className="ziply-plan-card">
            <h3 className="ziply-plan-name">FIBER GIG</h3>
            <p className="ziply-plan-from">From</p>
            <p className="ziply-plan-price"><span>$</span>60</p>
            <p className="ziply-plan-period">Monthly</p>
            <ul className="ziply-plan-features">
                <li><span className="ziply-check-icon">✓</span> Symmetric 1 Gig Upload and Download Speeds</li>
                <li><span className="ziply-check-icon">✓</span> Enjoy unlimited internet access on all your devices</li>
                <li><span className="ziply-check-icon">✓</span> Watch your favorite movies and TV shows in 8K</li>
                <li><span className="ziply-check-icon">✓</span> Broadcast live videos and podcasts</li>
                <li><span className="ziply-check-icon">✓</span> No annual contracts</li>
            </ul>
            <a href="tel:+18442172287" className="ziply-plan-btn">+1-888-348-6689</a>
            <p className="ziply-disclaimer">Not available in all areas. Advertised speed for wired connection. Actual speeds, including over WiFi, may vary and are not guaranteed.</p>
        </div>

        {/* <!-- Plan 3 (Featured) --> */}
        <div className="ziply-plan-card featured">
            <h3 className="ziply-plan-name">2 GIG FIBER</h3>
            <p className="ziply-plan-from">From</p>
            <p className="ziply-plan-price"><span>$</span>80</p>
            <p className="ziply-plan-period">Monthly</p>
            <ul className="ziply-plan-features">
                <li><span className="ziply-check-icon">✓</span> Symmetric 2 Gig Upload and Download Speeds</li>
                <li><span className="ziply-check-icon">✓</span> Enjoy unlimited internet access on up to 4 devices</li>
                <li><span className="ziply-check-icon">✓</span> Watch your favorite movies and TV shows in 16K</li>
                <li><span className="ziply-check-icon">✓</span> Livestream professional gaming feed with your followers</li>
                <li><span className="ziply-check-icon">✓</span> No annual contracts</li>
            </ul>
            <a href="tel:+18442172287" className="ziply-plan-btn">+1-888-348-6689</a>
            <p className="ziply-disclaimer">Not available in all areas. Advertised speed for wired connection. Actual speeds, including over WiFi, may vary and are not guaranteed.</p>
        </div>
    </div>
</div>
       
      {/* Power Section */}
      <section className="ziply-power-section py-16 bg-gray-100">
        <div className="container mx-auto px-4">
          <div className="flex flex-wrap items-center">
            <div className="w-full md:w-1/2 mb-8 md:mb-0">
              <div className="text-center md:text-left pr-0 md:pr-8">
                <h2 className="text-2xl md:text-3xl font-bold mb-4">Experience The Power Of<br />Fast Internet</h2>
                
                <p className="mb-4">Ziply Fiber's Multi-Gig Internet Plans Are Built To Bring You The Speed And Reliability You Need Today And For The Future. Choose From 1 Gig, 2 Gig, 5 Gig Or Even 10 Gig Internet Speeds – The Fastest Home Internet Plan In America.</p>
                
                <p className="mb-6">Multi-Gig Fiber Connectivity For Gamers, Content Creators, Remote Workers.</p>
                
                <a href="tel:18442737297" className="ziply-phone-btn bg-blue-500 text-white py-2 px-6 rounded-full inline-flex items-center">
                  <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5 mr-2" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 5a2 2 0 012-2h3.28a1 1 0 01.948.684l1.498 4.493a1 1 0 01-.502 1.21l-2.257 1.13a11.042 11.042 0 005.516 5.516l1.13-2.257a1 1 0 011.21-.502l4.493 1.498a1 1 0 01.684.949V19a2 2 0 01-2 2h-1C9.716 21 3 14.284 3 6V5z" />
                  </svg>
                  +1-888-348-6689
                </a>
              </div>
            </div>
            <div className="w-full md:w-1/2">
              <img src={provider4} alt="Business professionals using fast internet" className="rounded-lg w-full h-auto" />
            </div>
          </div>
        </div>
      </section>

      {/* Advantages Section */}
      <section className="ziply-advantages-section py-16">
        <div className="container mx-auto px-4 text-center">
          <h2 className="text-2xl md:text-3xl font-bold mb-8">Fiber-ziplyic Internet Delivers<br />Unparalleled Advantages</h2>
          <p className="mb-12">Over Outdated Cable Connections</p>
          
          <div className="ziply-advantages-grid flex flex-wrap justify-center">
            <div className="w-full md:w-1/4 p-4">
              <img src={provider5} alt="Gaming with fiber ziplyic" className="rounded-lg w-full h-auto mb-4" />
              <h3 className="font-bold mb-2">Gaming With Fiber-ziplyic</h3>
              <p className="text-sm">Low latency for seamless gaming and streaming</p>
            </div>
            
            <div className="w-full md:w-1/4 p-4">
              <img src={provider6} alt="Business professional with laptop" className="rounded-lg w-full h-auto mb-4" />
              <h3 className="font-bold mb-2">Unrestricted Internet</h3>
              <p className="text-sm">You don't have to worry about usage caps</p>
            </div>
            
            <div className="w-full md:w-1/4 p-4">
            <img src={provider7} alt="Business professional with laptop" className="rounded-lg w-full h-auto mb-4" />

              <h3 className="font-bold mb-2">Modern Internet</h3>
              <p className="text-sm">Future-proof technology for lasting performance</p>
            </div>
            
            <div className="w-full md:w-1/4 p-4">
            <img src={provider8} alt="Business professional with laptop" className="rounded-lg w-full h-auto mb-4" />

              <h3 className="font-bold mb-2">The Fastest WiFi</h3>
              <p className="text-sm">Enhanced WiFi coverage for your entire home</p>
            </div>
          </div>
        </div>
      </section>
    </div>

    <WideCoverage/>
    <Footer/>
    </>
  );
};

export default ZiplyfiberProvider;